import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import FocusTemplateMarketplaceControls from 'components/common/buttons/FocusTemplateMarketplaceControls';
import HabitPackActionButton from 'components/common/buttons/HabitPackActionButton';
import PackPreviewActionsWrapper from './PackPreviewActionsWrapper';
import { FocusModeTemplateType } from 'interfaces/common.interface';
import { focusTemplateActionsSelector } from 'store/reducer/focus-mode/selectors';
import { ATTRIB } from 'constants/test';
import { PackPickerVariant } from 'enums';
import {
  canInstallOrUninstallMarketplaceEntity,
  canManageMarketplaceEntity,
  canUseMarketplaceAuthActions
} from 'utils/marketplace.util';

const PackPreviewFocusTemplateActions = ({
  variant
}: {
  variant: PackPickerVariant;
}) => {
  const {
    currentViewedFocusTemplate,
    userInstalledFocusTemplates,
    userId,
    isUserAdmin
  } = useAppSelectorShallow(focusTemplateActionsSelector);

  const canUseAuthActions = canUseMarketplaceAuthActions(userId);
  const canInstallOrUninstall =
    canInstallOrUninstallMarketplaceEntity(userId);
  const installedFocusTemplateIds = userInstalledFocusTemplates?.map(
    (focusTemplate: FocusModeTemplateType) => focusTemplate.id
  );
  const userHasFocusTemplateInstalled =
    currentViewedFocusTemplate?.id &&
    installedFocusTemplateIds?.includes(currentViewedFocusTemplate.id);
  const isOwner = currentViewedFocusTemplate?.author_id === userId;
  const canManage =
    canUseAuthActions && canManageMarketplaceEntity(isOwner, isUserAdmin);

  return (
    <PackPreviewActionsWrapper>
      {variant === PackPickerVariant.MARKETPLACE && canInstallOrUninstall && (
        <>
          {userHasFocusTemplateInstalled ? (
            <HabitPackActionButton
              text={t('market.uninstall')}
              data-testid={ATTRIB.DATA_TESTID.FOCUS_TEMPLATE_ACTION_UNINSTALL}
            />
          ) : (
            <HabitPackActionButton
              text={t('market.install')}
              data-testid='focus-template-action-install'
            />
          )}
        </>
      )}
      {canManage && (
        <>
          <HabitPackActionButton
            text={t('market.edit')}
            data-testid={ATTRIB.DATA_TESTID.FOCUS_TEMPLATE_ACTION_EDIT}
          />
          <HabitPackActionButton
            text={t('market.delete')}
            data-testid={ATTRIB.DATA_TESTID.FOCUS_TEMPLATE_ACTION_DELETE}
          />
        </>
      )}
      {canUseAuthActions && isOwner && currentViewedFocusTemplate && (
        <FocusTemplateMarketplaceControls
          focusTemplate={currentViewedFocusTemplate}
        />
      )}
    </PackPreviewActionsWrapper>
  );
};

export default PackPreviewFocusTemplateActions;
